import { IUserValue } from "@Models/IUserDetails";
import UserService from "@Services/UserService";
import { uniqueArrayOfObjectsByKey } from "@Utils";
import { notification } from "antd";
import { useEffect, useState } from "react";

/*
 * Return a list of users whose first, last names or email match the search
 * term. The call will always post a minimum of three characters.
 */
export const useSearchPotentialConnections = (searchTerm = "") => {
    const [data, setData] = useState<IUserValue[]>([]);
    const [isSearching, setIsSearching] = useState(false);

    useEffect(() => {
        const userService = new UserService();
        const fetchData = async () => {
            setIsSearching(true);
            const result = await userService.searchByNameAndEmail(searchTerm);
            const options: IUserValue[] =
                !result?.hasErrors && !!result?.value?.users?.length
                    ? result.value.users.map((user) => {
                          return {
                              label: user.fullName,
                              value: user.userId,
                          };
                      })
                    : [];

            setData(uniqueArrayOfObjectsByKey(options.flat(), "value"));
            setIsSearching(false);
        };

        fetchData().catch(() => {
            notification.error({ message: "Unable to retrieve connections" });
        });
    }, [searchTerm]);

    return {
        data,
        isSearching,
    };
};
